// ...existing code...
import React, { useEffect, useState, useCallback } from "react";
import { BrowserRouter } from "react-router-dom";
import { WebPaths } from "./routes/Paths";
import { GlobalContext } from "./GlobalContext";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import axios from "axios";

import {
	// DarkTheme,
	LightTheme,
	//CustomTheme
} from "./styles/themes";
import { auditPost } from "./api/config";

const App = () => {
	// Log para monitorear cambios en viewPermissions

	const [authenticated, setAuthenticated] = useState(false);
	const [openLeft, setOpenLeft] = useState(localStorage.getItem("openLeft") === "true");
	const [openRight, setOpenRight] = useState(
		localStorage.getItem(`right-${window.location.pathname}`) === "true"
	);
	const [openSubButtons, setOpenSubButtons] = useState(
		localStorage.getItem("openSubButtons") === "true"
	);
	const [authLoading, setAuthLoading] = useState(true);
	const [site_id, setSiteId] = useState(null);
	// LOG: Cambio de site
	useEffect(() => {}, [site_id]);
	const [permissions, setPermissions] = useState([]);
	const [groupedPermissions, setGroupedPermissions] = useState({});
	const [allSubPermissions, setAllSubPermissions] = useState({});
	const [viewPermissions, setViewPermissions] = useState({
		config: false,
		upload: false,
		simulation: false,
		dashboard: false,
		audit: false,
		execute: false,
		review: false,
	});

	useEffect(() => {
		setPermissions([]);
		setGroupedPermissions({});
		setAllSubPermissions({});
		setViewPermissions({
			config: false,
			upload: false,
			simulation: false,
			dashboard: false,
			audit: false,
			execute: false,
			review: false,
		});
		setPermissionsRol(null); // Forzar reseteo para que el efecto de permisos se dispare siempre
	}, [site_id, authenticated]);
	const [permissionsRol, setPermissionsRol] = useState(null);
	const [user, setUser] = useState("");

	const isGranted = (module, subModule, permission) => {
		if (allSubPermissions[module]) {
			if (allSubPermissions[module][subModule]) {
				if (allSubPermissions[module][subModule][permission]) {
					return allSubPermissions[module][subModule][permission].granted;
				} else {
					return allSubPermissions[module][subModule].granted;
				}
			}
		}
		return false;
	};

	const getModuleId = useCallback(
		(module, subModule, permission) => {
			if (allSubPermissions[module]) {
				if (allSubPermissions[module][subModule]) {
					if (allSubPermissions[module][subModule][permission]) {
						return allSubPermissions[module][subModule][permission].permissions_id;
					} else {
						return allSubPermissions[module][subModule].permissions_id;
					}
				}
			}
			return null;
		},
		[allSubPermissions]
	);

	const initializeAllSubPermissions = (template) => {
		const initializedTemplate = {};
		for (const module in template) {
			initializedTemplate[module] = {};
			for (const subModule in template[module]) {
				if (typeof template[module][subModule] === "object") {
					initializedTemplate[module][subModule] = {};
					for (const permission in template[module][subModule]) {
						initializedTemplate[module][subModule][permission] = {
							granted: false,
							permissions_id: null,
						};
					}
				} else {
					initializedTemplate[module][subModule] = {
						granted: false,
						permissions_id: null,
					};
				}
			}
		}
		return initializedTemplate;
	};

	const updateAllSubPermissions = (allSubPermissions, groupedPermissions) => {
		for (const permission in groupedPermissions) {
			groupedPermissions[permission].forEach((item) => {
				if (allSubPermissions.hasOwnProperty(permission)) {
					for (const subPermission in allSubPermissions[permission]) {
						if (allSubPermissions[permission].hasOwnProperty(item.permissions)) {
							allSubPermissions[permission][item.permissions].granted = true;
							allSubPermissions[permission][item.permissions].permissions_id = item.permissions_id;
						} else if (allSubPermissions[permission][subPermission].hasOwnProperty(item.permissions)) {
							allSubPermissions[permission][subPermission][item.permissions].granted = true;
							allSubPermissions[permission][subPermission][item.permissions].permissions_id =
								item.permissions_id;
						}
					}
				}
			});
		}
	};

	// useEffect(() => {
	// 	const checkSession = async () => {
	// 		try {
	// 			const response = await axios.get(`/auth/check-session`, {
	// 				withCredentials: true,
	// 			});
	// 			if (response.status === 200) {
	// 				setAuthenticated(true);
	// 				setSiteId(localStorage.getItem("siteId"));
	// 			} else {
	// 				setAuthenticated(false);
	// 				// const moduleId = getModuleId("Login", "Log Out");
	// 				// auditPost(moduleId);
	// 			}
	// 		} catch (error) {
	// 			setAuthenticated(false);
	// 			// const moduleId = getModuleId("Login", "Log Out");
	// 			// auditPost(moduleId);
	// 		}
	// 	};
	// 	checkSession();
	// }, [getModuleId]);

	useEffect(() => {
		(async () => {
			const api = axios.create({
				baseURL: process.env.REACT_APP_AUTH_URL,
				withCredentials: true,
			});
			try {
				const res = await api.get(`/user/current`, { headers: { accept: "application/json" } });
				if (res.status === 200) {
					setAuthenticated(true);

					setSiteId(localStorage.getItem("siteId"));
				} else {
					setAuthenticated(false);
				}
			} catch {
				setAuthenticated(false);
			} finally {
				setAuthLoading(false);
			}
		})();
	}, []);

	useEffect(() => {
		const interval = setInterval(async () => {
			const api = axios.create({
				baseURL: process.env.REACT_APP_AUTH_URL,
				withCredentials: true,
			});
			try {
				const response = await api.get(`/user/current`);

				if (!response.status === 200) {
					setAuthenticated(false);
				}
			} catch (error) {
				setAuthenticated(false);
			}
		}, 10 * 60 * 1000);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		const handlePermissions = async () => {
			if (authenticated && site_id) {
				const apiAuth = axios.create({
					baseURL: process.env.REACT_APP_AUTH_URL,
					withCredentials: true,
				});
				const decodedData = await apiAuth.get(`/user/current`, {
					headers: {
						accept: "application/json",
					},
				});

				const decoded = decodedData.data;

				if (decoded) {
					try {
						let rolesIds = decoded.roles_site_id;
						const user = decoded.username;

						const parsedRolesIds = {};
						for (let key in rolesIds) {
							let parsedKey = parseFloat(key);

							if (parsedKey % 1 === 0) {
								parsedKey = Math.floor(parsedKey);
							}
							parsedRolesIds[parsedKey] = rolesIds[key];
						}

						rolesIds = parsedRolesIds;

						if (rolesIds && rolesIds[site_id]) {
							const moduleId = rolesIds[site_id];

							setPermissionsRol(moduleId);
							setUser(user);
						} else {
							console.warn("Site ID not found in roles", { site_id, rolesIds });
						}
					} catch (error) {
						console.error("Error decoding token:", error);
					}
				} else {
					console.warn("No access token found");
				}
			}
		};
		handlePermissions();
	}, [authenticated, site_id]);

	useEffect(() => {
		const fetchRoleId = async () => {
			const api = axios.create({
				baseURL: process.env.REACT_APP_CORE_URL,
				withCredentials: true,
			});
			const apiAuth = axios.create({
				baseURL: process.env.REACT_APP_AUTH_URL,
				withCredentials: true,
			});

			if (authenticated && permissionsRol) {
				try {
					const response = await apiAuth.get(`/role_permissions/get/${permissionsRol}`, {
						headers: {
							accept: "application/json",
						},
					});

					const allSubPermissionsEndpoint = await api.get(`/permissions_modules/get_all`);
					const allSubPermissionsTemplate = allSubPermissionsEndpoint.data;

					const newPermissions = [];
					const newViewPermissions = {
						config: false,
						upload: false,
						simulation: false,
						dashboard: false,
						audit: false,
						execute: false,
						review: false,
					};

					const groupedPermissions = {};

					response.data.forEach((item) => {
						let moduleName = item.parent_module_name || item.module_name;
						if (!groupedPermissions[moduleName]) {
							groupedPermissions[moduleName] = [];
						}
						groupedPermissions[moduleName].push({
							permissions: item.description,
							action: item.action,
							permissions_id: item.id_permission_modules,
						});

						newPermissions.push(moduleName);

						switch (moduleName) {
							case "Configuración":
								newViewPermissions.config = true;
								break;
							case "Carga de Archivos":
								newViewPermissions.upload = true;
								break;
							case "Simulación":
								newViewPermissions.simulation = true;
								break;
							case "Dashboard":
								newViewPermissions.dashboard = true;
								break;
							case "Auditoria":
								newViewPermissions.audit = true;
								break;
							case "Sim. Masivas":
								newViewPermissions.execute = true;
								break;
							case "Revisión":
								newViewPermissions.review = true;
								break;
							default:
								break;
						}
					});

					setGroupedPermissions(groupedPermissions);
					setPermissions(newPermissions);

					const updatedPermissions = initializeAllSubPermissions(allSubPermissionsTemplate);
					updateAllSubPermissions(updatedPermissions, groupedPermissions);
					setAllSubPermissions(updatedPermissions);
					setViewPermissions(newViewPermissions);
				} catch (error) {
					console.error("Error en fetchRoleId:", error);
					if (error.response && error.response.status === 401) {
						console.error("Error en fetchRoleId:", error.response.data);
					}
				}
			} else {
				setPermissions([]);
				setGroupedPermissions({});
				setAllSubPermissions({});
				setViewPermissions({
					config: false,
					upload: false,
					simulation: false,
					dashboard: false,
					audit: false,
					execute: false,
				});
			}
		};
		fetchRoleId();
	}, [authenticated, permissionsRol]);
	useEffect(() => {}, [viewPermissions]);
	useEffect(() => {
		const postAuditLog = async () => {
			try {
				if (authenticated && Object.keys(groupedPermissions).length > 0) {
					const moduleId = getModuleId("Login", "Log In");
					if (moduleId) {
						await auditPost(moduleId, site_id);
					}
				}
			} catch (error) {
				console.error("Error posting audit log:", error);
			}
		};

		postAuditLog();
	}, [authenticated, groupedPermissions, getModuleId, site_id]);

	const handlerSideLeft = (bool) => {
		localStorage.setItem("openLeft", bool);
		setOpenLeft(bool);

		// Si se cierra el menú de la izquierda, forzamos el cierre de los sub-botones
		if (!bool) {
			localStorage.setItem("openSubButtons", false);
			setOpenSubButtons(false);
		}
	};

	const handlerSideRight = (bool) => {
		localStorage.setItem(`right-${window.location.pathname}`, bool);
		setOpenRight(bool);
	};

	const handlerSubButtons = (bool) => {
		localStorage.setItem("openSubButtons", bool);
		setOpenSubButtons(bool);
	};

	useEffect(() => {
		setOpenLeft(localStorage.getItem("openLeft") === "true");
		setOpenRight(localStorage.getItem(`right-${window.location.pathname}`) === "true");
	}, []);

	return (
		<GlobalContext.Provider
			value={{
				authenticated,
				setAuthenticated,
				authLoading,
				permissions,
				setPermissions,
				groupedPermissions,
				setGroupedPermissions,
				allSubPermissions,
				setAllSubPermissions,
				viewPermissions,
				setViewPermissions,
				permissionsRol,
				setPermissionsRol,
				user,
				setUser,
				getModuleId,
				isGranted,
				openLeft,
				handlerSideLeft,
				openRight,
				handlerSideRight,
				site_id,
				setSiteId,
				openSubButtons,
				handlerSubButtons,
			}}
		>
			<ThemeProvider theme={LightTheme}>
				<CssBaseline />
				<BrowserRouter>
					{authLoading ? (
						<Box sx={{ p: 4 }}>Cargando sesión…</Box>
					) : (
						<Box
							sx={{
								display: { xs: "none", sm: "none", md: "block" },
								overflow: "hidden",
							}}
						>
							<WebPaths />
						</Box>
					)}

					{/* <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
						<MobilePaths />
					</Box> */}
				</BrowserRouter>
			</ThemeProvider>
		</GlobalContext.Provider>
	);
};

export default App;
